import script from "./CenterRankingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CenterRankingBar.vue?vue&type=script&setup=true&lang=js"

import "./CenterRankingBar.vue?vue&type=style&index=0&id=9ac17290&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac17290"]])

export default __exports__